import { render, staticRenderFns } from "./MultiPictureForm.vue?vue&type=template&id=f0ed848e"
import script from "./MultiPictureForm.vue?vue&type=script&lang=js"
export * from "./MultiPictureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports